import { Matomo } from '@gaming/srvg-matomo';
import { openStats } from './utils/openStats';
import { setSelectedMatchday } from './utils/setSelectedMatchday';
import { receiveMessage } from './utils/receiveMessage';

export default function(app:any) {

    const piwikUrl = srvg.piwik.host.indexOf('//') !== -1 ? srvg.piwik.host : ("https:" === document.location.protocol ? "https://"+srvg.piwik.host : "http://"+srvg.piwik.host);

    // Init Matomo Piwik tracking
    Matomo.init({
        url: piwikUrl,
        siteId: srvg.piwik.trackingId
    });
    srvg.Matomo = Matomo;

    if(!(window as any).handleOpenVblStats) {
        (window as any).handleOpenVblStats = openStats;
    }

    if(!(window as any).handleSetSelectedMatchday) {
        (window as any).handleSetSelectedMatchday = setSelectedMatchday;
    }

    if(!(window as any).openVblStats) {
        (window as any).openVblStats = openStats;
    }

    if(!(window as any).setSelectedMatchday) {
        (window as any).setSelectedMatchday = setSelectedMatchday;
    }

    // listen to customerMessages from parent via postMessage
    // ---------------------------------------------------------------------------------------------------------------------
    window.addEventListener("message", receiveMessage, false);

    if(!(window as any).receiveMessage) {
        (window as any).receiveMessage = receiveMessage;
    }
}